import gql from 'graphql-tag'

export const ENRICH_SESSION = gql`
  mutation EnrichSession {
    enrichSession {
      _id
      email
      firstName
      fullName
      outlookId
      repliconId
      startDate
      position
      employeeType
    }
  }
`
